export default __webpack_public_path__ + "alberta-sos.f4fa7d5a47212a5542b5.svg";